import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import { partners1, partners10, partners11, partners12, partners13, partners14, partners15, partners16, partners17, partners18, partners19, partners2, partners20, partners21, partners22, partners3, partners4, partners5, partners6, partners7, partners8, partners9, rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import './Partners.css'

const Brands = () => {
  const { t } = useTranslation();

  const newsItems = [
    {
      id: 1,
      imgSrc: partners1,
    },
    {
      id: 2,
      imgSrc: partners2,
    },
    {
      id: 3,
      imgSrc: partners3,
    },
    {
      id: 4,
      imgSrc: partners4,
    },
    {
      id: 5,
      imgSrc: partners5,
    },
    {
      id: 6,
      imgSrc: partners6,
    },
    {
      id: 7,
      imgSrc: partners7,
    },
    {
      id: 8,
      imgSrc: partners8,
    },
    {
      id: 9,
      imgSrc: partners9,
    },
    {
      id: 10,
      imgSrc: partners10,
    },
    {
      id: 11,
      imgSrc: partners11,
    },
    {
      id: 12,
      imgSrc: partners12,
    },
    {
      id: 13,
      imgSrc: partners13,
    },
    {
      id: 14,
      imgSrc: partners14,
    },
    {
      id: 15,
      imgSrc: partners15,
    },
    {
      id: 16,
      imgSrc: partners16,
    },
    {
      id: 17,
      imgSrc: partners17,
    },
    {
      id: 18,
      imgSrc: partners18,
    },
    {
      id: 19,
      imgSrc: partners19,
    },
    {
      id: 20,
      imgSrc: partners20,
    },
    {
      id: 21,
      imgSrc: partners21,
    },
    {
      id: 22,
      imgSrc: partners22,
    },
  
  ];

  return (
    <div className='w-full justify-center items-center relative mt-[90px] md:mt-[118px] flex '>
      <div className='md:max-w-container max-w-containerSm flex flex-col mx-auto justify-between relative py-8'>
        {/* Başlık */}
        <div className='flex justify-between items-center h-[50px]'>
          <div className='flex items-center'>
            <p className='text-[24px] md:text-[32px] font-medium text-[#008A7F]'>{t("Tərəfdaşlarımız")}</p>
          </div>
          <div className="absolute top-8 right-0 flex gap-2">
            <button className="swiper-button-prev-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
            <button className="swiper-button-next-custom border-2 border-[#E5E5E5] group hover:border-[#01A396] p-[10px] rounded-lg">
              <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#01A396]"></i>
            </button>
          </div>
        </div>

        {/* Slider */}
        <div className='mt-10'>
          <Swiper
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: '.swiper-button-next-custom',
              prevEl: '.swiper-button-prev-custom',
            }}
            modules={[Pagination, Navigation]}
            breakpoints={{
              280: { slidesPerView: 3 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 8 },
            }}
          >
            {newsItems.map((item) => (
              <SwiperSlide key={item.id}>
               <div className='md:w-[150px] h-[60px] flex items-center'>
            <img src={item.imgSrc} className='w-full' alt='' />
        </div>
              </SwiperSlide>
            ))} 
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Brands;
